import { useLayoutEffect, useState } from "react";
import type { RefObject } from "react";

/** Altura real do `thead` (o título pode quebrar em duas linhas); `undefined` até medir, sem cabeçalho ou com altura 0. */
export function useHeaderHeight(
  tableRef: RefObject<HTMLElement | null>,
  measureKey: string,
): number | undefined {
  const [height, setHeight] = useState<number>();

  // `measureKey` muda quando a tabela entra na tela (o wrapper só existe na vista `table`) e quando o `DataTable` remonta.
  useLayoutEffect(() => {
    const header = tableRef.current?.querySelector("thead") ?? null;
    if (!header) {
      setHeight(undefined);
      return;
    }
    const measure = () => {
      const { height: measured } = header.getBoundingClientRect();
      setHeight(measured > 0 ? measured : undefined);
    };
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    return () => observer.disconnect();
  }, [tableRef, measureKey]);

  return height;
}
